// extracted by mini-css-extract-plugin
module.exports = {"pageGallery__title":"page_pageGallery__title__BEJX8","pageGallery__grid":"page_pageGallery__grid__zhtWr","pageGallery__img":"page_pageGallery__img__2gMH3"};